module.exports = __webpack_public_path__ + "img/timer.f810c83a.svg";